import { render, staticRenderFns } from "./ScrollHorizontal.vue?vue&type=template&id=c1d13354&scoped=true&"
import script from "./ScrollHorizontal.vue?vue&type=script&lang=js&"
export * from "./ScrollHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ScrollHorizontal.vue?vue&type=style&index=0&id=c1d13354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d13354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1d13354')) {
      api.createRecord('c1d13354', component.options)
    } else {
      api.reload('c1d13354', component.options)
    }
    module.hot.accept("./ScrollHorizontal.vue?vue&type=template&id=c1d13354&scoped=true&", function () {
      api.rerender('c1d13354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/ScrollHorizontal.vue"
export default component.exports